import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { UITheme } from '@galaxy/partner';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { uiThemeFromEnum, uiThemeToEnum, UserBrandingService } from '../../../../core/user-branding.service';
import { CustomizeApiService } from '../customize-api.service';

@Component({
  selector: 'app-brand-color',
  templateUrl: './brand-color.component.html',
  styleUrls: ['./brand-color.component.scss'],
})
export class BrandColorComponent implements OnInit {
  brandingForm = this.formBuilder.group({
    brandColor: ['#', Validators.pattern(/^[#]\S+/)],
    uiTheme: [0],
  });

  @Input()
  uiTheme: UITheme;

  @Input()
  primaryColor: string;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private customizeApiService: CustomizeApiService,
    private userBrandingService: UserBrandingService,
    private snackbarService: SnackbarService,
    private translations: TranslateService,
  ) {}

  ngOnInit(): void {
    this.brandingForm.patchValue({
      brandColor: '#' + this.primaryColor,
      uiTheme: uiThemeFromEnum(this.uiTheme),
    });
  }

  submitForm(): void {
    const color = this.brandingForm.value.brandColor.slice(1);
    const theme = this.brandingForm.value.uiTheme === 1 ? 'light' : 'dark';
    this.customizeApiService.setPrimaryColor(color, theme).subscribe(
      () => {
        this.userBrandingService.setUiTheme(uiThemeToEnum(theme));
        this.snackbarService.successSnack(this.translations.instant('CUSTOMIZE_PARTNER.COLOR.FORM_SUCCESS'));
      },
      (err) => {
        console.error(err);
        // raise snack alert
        let message;
        if (err.status === 500) {
          message = this.translations.instant('CUSTOMIZE_PARTNER.COLOR.FORM_ERROR_UNKNOWN');
        }
        this.snackbarService.errorSnack(message);
      },
    );
  }
}
